module.exports = __webpack_public_path__ + "static/media/pg.db632ada.svg";